import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "person",
  initialState: {
    isAuthenticated: false,
    token: "",
  },
  reducers: {
    authenticateUser: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = "";
      localStorage.removeItem("person"); // Clear localStorage on logout
    },
  },
});

export const { authenticateUser, logout } = authSlice.actions;

export default authSlice.reducer;
